export const META_DEFAULT_BASE_URL = 'https://www.udemy.com';

// Add custom global application constants below
// <<Stencil::Block(globalAppConstants)>>
export const UB_HOME_URL = 'https://business.udemy.com';
// <</Stencil::Block>>
